import React, { useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import Select from "react-select";
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Swal from "sweetalert2";
import { ContentLoader, NoRecords } from '../Shimmer';

const InspectionFormThroughProfile = () => {
    const { apiURL, apiHeaderJson, user_profile_id } = useContext(ConfigContext);
    const [inspectionFormData, setInspectionFormData] = useState([]);
    const [inspectionFormID, setinspectionFormID] = useState(0);
    const [consultantData, setConsultantData] = useState([]);
    const [inspectionRequestData, setInspectionRequestData] = useState([]);
    const [loadingList, setLoadingList] = useState(false);
    const [briefDescription, setBriefDescription] = useState("");
    const [consultantId, setConsultantId] = useState(0);
    const { project_id } = useParams();
    const [projectItems, setProjectItems] = useState([]);
    const [itemId, setItemId] = useState(0);
    const [attachments, setAttachments] = useState([]);

    const handleFileChange = (e) => {
        const newFiles = Array.from(e.target.files);
        setAttachments((prevFiles) => [...prevFiles, ...newFiles]);
        e.target.value = ''; // Reset input so same file can be selected again
    };

    const handleRemoveFile = (index) => {
        setAttachments((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const handleSelect = (selectedOption) => {
        setinspectionFormID(selectedOption ? selectedOption.value : null);
    };

    const handleConsuntantSelect = (selectOption) => {
        setConsultantId(selectOption ? selectOption.value : null);
    };
    const handleSelectItem = (selectOption) => {
        setItemId(selectOption ? selectOption.value : null)
    }

    const resetForm = () => {
        setinspectionFormID(0);
        setConsultantId(0);
        setBriefDescription("");
        setItemId(0)
    };

    const getInspectionForm = async () => {
        try {
            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}api/inspections/GetInspections`, { headers });
            const { data } = response.data;
            setInspectionFormData(
                data.map((row) => ({
                    value: row.inspection_id,
                    label: row.inspection_title
                }))
            );
        } catch (error) {
            console.log(error);
        }
    };

    const getProjectConsultant = async () => {
        try {
            const response = await axios.get(`${apiURL}api/project-consultants/project/${project_id}`);
            const { data, success } = response.data;
            if (success === true) {
                setConsultantData(
                    data.map((row) => ({
                        value: row.consultant_id,
                        label: row.profile_name
                    }))
                );
            }
        } catch (error) {
            console.log(error);
        }
    };

    const GetList = async () => {
        setLoadingList(true);
        try {
            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}api/inspections/GetInspectionsByContractor`, {
                params: { contractor_id: user_profile_id },
                headers
            });
            const data = response.data;

            if (data.success) {
                setInspectionRequestData(data.data);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingList(false);
        }
    };

    const getProjectItemList = async () => {
        try {
            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}api/requests/GetProjectItems`, { params: { project_id: project_id } })
            const { data, success } = response.data;

            if (success === true) {
                setProjectItems(
                    data.map((row) => ({
                        value: row.pi_item_id,
                        label: row.item_name
                    }))
                )
            }

        } catch (error) {
            console.log(error);

        }

    }

    const getStatus = (status) => {
        if (status === "0") return "Pending";
        if (status === "1") return "Approved";
        if (status === "2") return "Rejected";
    };

    const getBadge = (status) => {
        if (status === "0") return "badge bg-warning-subtle text-warning";
        if (status === "1") return "badge bg-success-subtle text-success";
        if (status === "2") return "badge bg-danger-subtle text-danger";
    };

    const handleSubmit = async () => {
        try {
            const Body = {
                inspection_id: inspectionFormID,
                contractor_id: user_profile_id,
                project_id,
                consultant_id: consultantId,
                description: briefDescription
            };
            const headers = apiHeaderJson;
            const response = await axios.post(`${apiURL}api/inspections/RequestProjectInspection`, Body, { headers });
            const { success, message } = response.data;

            if (success === true) {
                await Swal.fire({
                    title: "Success",
                    text: message,
                    icon: "success",
                    timer: 1000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                });
                GetList();
                resetForm();
                document.getElementById("close-inspection-modal")?.click();
            }
        } catch (error) {
            await Swal.fire({
                title: "Error",
                html: error.message || "Something went wrong!",
                icon: "error",
            });
        }
    };

    const CancelRequest = async (inspectionID) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, cancel it!",
            });

            if (result.isConfirmed) {
                const response = await axios.post(`${apiURL}api/inspections/CancelInspectionRequest`, {
                    project_inspection_id: inspectionID,
                    contractor_id: user_profile_id
                });
                const { success, message } = response.data;

                await Swal.fire({
                    title: `${success ? "Success" : "Failed"}`,
                    text: message,
                    icon: success ? "success" : "error",
                    timer: 1000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                });

                if (success) GetList();
            }
        } catch (error) {
            await Swal.fire({
                title: "<strong>Error</strong>",
                html: error.message || "Something went wrong!",
                icon: "error",
            });
        }
    };

    useEffect(() => {
        getInspectionForm();
        GetList();
        getProjectItemList()
    }, []);

    useEffect(() => {
        if (project_id) getProjectConsultant();
    }, [project_id]);

    return (
        <div className="col-xxl-12">
            <div className="card">
                <div className="card-body">
                    <div className="card-header d-flex align-items-center mb-4">
                        <h5 className="card-title flex-grow-1 mb-0">Inspection</h5>
                        <div className="flex-shrink-0">
                            <button
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#InspectionModal"
                                className="btn btn-secondary"
                            >
                                <i className="ri-file-edit-line me-1 align-bottom" /> Add Inspection Request
                            </button>
                        </div>
                    </div>

                    <div className="row mt-3">
                        {loadingList ? (
                            <ContentLoader />
                        ) : inspectionRequestData.length === 0 ? (
                            <NoRecords />
                        ) : (
                            inspectionRequestData.map((item) => (
                                <div className="col-xxl-3 col-sm-6 mt-4" key={item.project_inspection_id}>
                                    <div
                                        className="card profile-project-card shadow-none profile-project-warning mb-3"
                                        style={{ position: "relative" }}
                                    >
                                        {item.inspection_request_status !== "1" && (
                                            <button
                                                onClick={() => CancelRequest(item.project_inspection_id)}
                                                className="btn btn-sm btn-outline-danger"
                                                style={{
                                                    position: "absolute",
                                                    top: "10px",
                                                    right: "10px",
                                                    zIndex: 1,
                                                }}
                                            >
                                                <i className="ri-close-fill" style={{ fontSize: "14px" }}></i>
                                            </button>
                                        )}
                                        <div className="card-body p-4">
                                            <div className="text-muted">
                                                <p className="mb-1">
                                                    <strong>Project Name:</strong> {item?.project_title}
                                                </p>
                                                <p className="mb-1">
                                                    <strong>Project Address:</strong> {item?.profile_address}
                                                </p>
                                                <p className="mb-1">
                                                    <strong>Consultant Name:</strong> {item?.profile_name}
                                                </p>
                                                <p className="mb-0">
                                                    <strong>Status:</strong>{" "}
                                                    <span className={`fw-semibold ${getBadge(item?.inspection_request_status)}`}>
                                                        {getStatus(item?.inspection_request_status)}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>

                {/* Modal */}
                <div
                    id="InspectionModal"
                    className="modal fade"
                    tabIndex={-1}
                    aria-labelledby="myModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">New Inspection Request</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    id="close-inspection-modal"
                                    onClick={()=>resetForm()}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <Select
                                        onChange={handleSelect}
                                        options={inspectionFormData}
                                        placeholder="Select Inspection Form"
                                        value={inspectionFormID ? inspectionFormData.find(opt => opt.value === inspectionFormID) : null}
                                    />
                                </div>
                                <div className="mb-3">
                                    <Select
                                        onChange={handleConsuntantSelect}
                                        options={consultantData}
                                        placeholder="Select Consultant"
                                        value={consultantId ? consultantData.find(opt => opt.value === consultantId) : null}
                                    />
                                </div>
                                <div className='mb-3'>
                                    <Select
                                        onChange={handleSelectItem}
                                        options={projectItems}
                                        placeholder="Select Item"
                                        value={itemId ? projectItems.find(opt => opt.value === projectItems) : null}
                                    />
                                </div>
                                <div className="col-md-12 mt-3">
                                    <div className="row">
                                        <div className="col-md-10">
                                            <input
                                                type="file"
                                                multiple
                                                className="form-control"
                                                onChange={handleFileChange}
                                            />
                                        </div>
                                        <div className="col-md-2 d-flex justify-content-center align-items-center">
                                            <input
                                                type="file"
                                                id="additionalFileInput"
                                                multiple
                                                className="d-none"
                                                onChange={handleFileChange}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm"
                                                onClick={() => document.getElementById('additionalFileInput').click()}
                                            >
                                                <i className="ri-add-circle-line fs-15"></i>
                                            </button>
                                        </div>
                                    </div>

                                    {attachments.length > 0 && (
                                        <div className="mt-3 border border p-3 rounded bg-white">
                                            <h6>Uploaded Files:</h6>
                                            <ul className="list-group">
                                                {attachments.map((file, index) => (
                                                    <li
                                                        key={index}
                                                        className="list-group-item d-flex justify-content-between align-items-center"
                                                    >
                                                        <span>{file.name}</span>
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => handleRemoveFile(index)}
                                                        >
                                                            <i className="ri-delete-bin-line"></i>
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>

                                <div className="mb-3 mt-3">
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        placeholder="Enter  Remark"
                                        value={briefDescription}
                                        onChange={(e) => setBriefDescription(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" onClick={()=>resetForm()} className="btn btn-light" data-bs-dismiss="modal" >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!briefDescription || !consultantId || !inspectionFormID}
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default InspectionFormThroughProfile;
